import { useEffect } from "react";
import { isLocalDev } from "../utils/env";

export default function RedirectToBookshelf({
  path,
  replace,
}: {
  path: string;
  replace?: boolean;
}) {
  useEffect(() => {
    const url = isLocalDev()
      ? `https://bookshelf-dev.vitalsource.com${path}`
      : path;
    if (replace) {
      window.location.replace(url);
    } else {
      window.location.href = url;
    }
  }, [path, replace]);

  return null;
}
